module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "TagItem",
    class: _vm.acState ? 'TagItemAc' : '',
    on: {
      "click": function($event) {
        return _vm.acStateFn(_vm.value)
      }
    }
  }, [_vm._v(_vm._s(_vm.name))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b0262a5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/tagitem/src/tagitem.vue
// module id = 510
// module chunks = 0